<section class="crm crm-profile">
  <article class="prof">
    @if (failed(); as message) {
      <p class="banner" role="alert">{{ message }}</p>
    }

    @if (lead(); as person) {
      <header class="prof-bar">
        <button class="prof-back" type="button" (click)="back()" aria-label="All leads">‹</button>
        <h1>{{ person.firstName }} {{ person.lastName }} <span>| {{ person.id }}</span></h1>
        <span class="prof-pill" [class.live]="person.online">{{ presence(person) }}</span>
        <span class="prof-pill page">{{ person.page || 'Not on the site' }}</span>
        <div class="prof-tools">
          <div class="prof-stat">
            <span>Availability</span>
            <svg viewBox="0 0 16 16" aria-hidden="true"><rect x="3" y="2" width="10" height="12" rx="1.5" /></svg>
          </div>
          <div class="prof-stat">
            <span>Score</span>
            <strong>—</strong>
          </div>
          <button class="prof-icon" type="button" (click)="step(-1)" [disabled]="atStart()" aria-label="Previous customer">‹</button>
          <button class="prof-reset" type="button">Reset Password</button>
          <div class="crm-bell-wrap">
            <button class="btn ghost crm-bell" type="button" (click)="noticesOpen.set(!noticesOpen())" [attr.aria-expanded]="noticesOpen()">
              Notifications
              @if (board.unread() > 0) {
                <strong class="crm-badge">{{ board.unread() }}</strong>
              }
            </button>
            @if (noticesOpen()) {
              <div class="crm-menu-back" (click)="noticesOpen.set(false)"></div>
              <section class="crm-notices" role="menu" aria-label="Notifications" (click)="$event.stopPropagation()">
                <h2>Notifications</h2>
                @for (item of board.items(); track item.id) {
                  <button type="button" class="crm-notice-row" [class.unread]="!item.read" (click)="openNotice(item)">
                    <strong>{{ item.body }}</strong>
                    <span>{{ when(item.createdAt) }}</span>
                  </button>
                } @empty {
                  <p>No notifications yet.</p>
                }
              </section>
            }
          </div>
          @if (admin()) {
            <button class="prof-credit" type="button" (click)="askCredit()">Add balance</button>
            <button class="prof-delete" type="button" (click)="askDelete()">Delete lead</button>
          }
          <button class="prof-icon" type="button" (click)="step(1)" [disabled]="atEnd()" aria-label="Next customer">›</button>
        </div>
      </header>

      <div class="prof-strip prof-metrics">
        <div><span>Customer Type</span><strong>Lead</strong></div>
        <div><span>Balance, $</span><strong>{{ money(person.balance) }}</strong></div>
        <div><span>Equity, $</span><strong>0</strong></div>
        <div><span>Credit, $</span><strong>0</strong></div>
        <div><span>Open P&amp;L, $</span><strong>0</strong></div>
        <div><span>Close P&amp;L, $</span><strong>0</strong></div>
        <div><span>Total P&amp;L, $</span><strong>0</strong></div>
        <div><span>Deposit, $</span><strong>0</strong></div>
        <div><span>Withdrawal, $</span><strong>0</strong></div>
        <div><span>Net Deposit, $</span><strong>0</strong></div>
        <div><span>Last Deposit</span><strong>-</strong></div>
      </div>

      <div class="prof-strip prof-meta">
        <div><span>Updated</span><strong>{{ stamp(notes()[0]?.createdAt || person.createdAt) }}</strong></div>
        <div><span>Updated by</span><strong>{{ notes()[0]?.authorName || '—' }}</strong></div>
        <div><span>Department</span><strong>Leads</strong></div>
        <div>
          <span>Assigned to</span>
          @if (admin()) {
            <strong class="prof-assign">
              <select [value]="assigneeId()" (change)="assigneeId.set($any($event.target).value)">
                <option value="" [selected]="assigneeId() === ''">Unassigned</option>
                @for (agent of agents(); track agent.id) {
                  <option [value]="agent.id" [selected]="assigneeId() === '' + agent.id">{{ agent.name }}</option>
                }
              </select>
              <button type="button" (click)="assign()">Assign</button>
            </strong>
          } @else {
            <strong>{{ person.assigneeName || 'Unassigned' }}</strong>
          }
        </div>
        <div><span>Auto-assigned Count</span><strong>0</strong></div>
      </div>

      <div class="prof-cards">
        <section>
          <h2>Main Info</h2>
          <div class="mi-status">
            <div>
              <span class="mi-k">Status</span>
              <strong>{{ label(person.status) }}</strong>
            </div>
            <button class="mi-pen" type="button" (click)="openComposer('Change status')" aria-label="Edit status">
              <svg viewBox="0 0 16 16"><path d="M9.2 2.8 13.2 6.8 5.5 14.5H1.5v-4z" /></svg>
            </button>
          </div>
          <div class="mi-split">
            <div><span class="mi-k">Network</span><strong>Lead</strong></div>
            <div><span class="mi-k">Placement</span><strong>{{ person.previousAssigneeName || person.assigneeName || '—' }}</strong></div>
          </div>
        </section>

        <section>
          <h2>Contact Info</h2>
          <div>
            <span class="mi-k">Phone</span>
            <div class="phone-row">
              <span class="lock" aria-hidden="true"><svg viewBox="0 0 16 16"><rect x="3.5" y="7" width="9" height="6.5" rx="1" /><path d="M5.5 7V5.2a2.5 2.5 0 0 1 5 0V7" /></svg></span>
              @if (callable(person.phone)) {
                <a class="qbtn" href="#" (click)="call($event, person.phone)">Call</a>
              }
            </div>
          </div>
          <div class="mail-block">
            <span class="mi-k">Email</span>
            <div class="mail-row">
              @if (person.email.includes('@')) {
                <button class="mail-ico" type="button" (click)="openMail()" aria-label="Email">✉</button>
              }
              @if (callable(person.phone)) {
                <a class="sms-link" [href]="'sms:' + dial(person.phone)" (click)="text($event, person.phone)">SMS</a>
              }
            </div>
          </div>
        </section>

        <section>
          <h2>Location Info</h2>
          <div class="loc">
            <div><span class="mi-k">Country</span><strong>{{ person.country || '—' }}</strong></div>
            <div><span class="mi-k">City</span><b>—</b></div>
            <div><span class="mi-k">Customer Time</span><strong>—</strong></div>
            <div><span class="mi-k">Language</span><b>—</b></div>
          </div>
        </section>

        <section class="personal-card">
          <h2>Personal notes</h2>
          <ul class="personal-notes">
            @for (item of personal(); track item.id) {
              <li>
                <p>{{ item.body }}</p>
                <div class="who">
                  <strong>{{ item.authorName }}</strong>
                  <time>{{ stamp(item.createdAt) }}</time>
                </div>
              </li>
            } @empty {
              <li class="empty">Only you can see notes you add here.</li>
            }
          </ul>
          <button type="button" class="prof-add note-open" (click)="openNote()">Add note</button>
        </section>
      </div>

      <section class="prof-support">
        <h2>Customer Support Note</h2>
        <p>No notes yet</p>
      </section>

      <nav class="prof-tabs" aria-label="Lead profile">
        <button type="button" [class.on]="tab() === 'activity'" (click)="tab.set('activity')">Activity</button>
        <button type="button" [class.on]="tab() === 'accounts'" (click)="tab.set('accounts')">Trading Accounts <i>0</i></button>
        <button type="button" [class.on]="tab() === 'transactions'" (click)="tab.set('transactions')">Transactions</button>
        <button type="button" [class.on]="tab() === 'compliance'" (click)="tab.set('compliance')">Compliance</button>
        <button type="button" [class.on]="tab() === 'profile'" (click)="tab.set('profile')">Full profile</button>
        <button type="button" [class.on]="tab() === 'comms'" (click)="tab.set('comms')">Communication Settings</button>
      </nav>

      @if (tab() === 'activity') {
        <section class="prof-panel prof-comments-panel">
          <div class="comments-head">
            <h2>Comments</h2>
            <button type="button" (click)="openComposer('Add comment')">Add comment</button>
          </div>
          <ul class="prof-comments">
            @for (note of notes(); track note.id) {
              <li>
                <p>{{ note.body }}</p>
                <div class="who">
                  <strong>{{ note.authorName }}</strong>
                  <time>{{ stamp(note.createdAt) }}</time>
                </div>
              </li>
            } @empty {
              <li>No comments yet.</li>
            }
          </ul>
        </section>
      } @else if (tab() === 'transactions') {
        <section class="prof-panel">
          <table class="txn">
            <thead>
              <tr>
                <th>ID</th>
                <th>Type</th>
                <th>Credit In Reason</th>
                <th>Credit Out Reason</th>
                <th>Status</th>
                <th>Amount</th>
                <th>Currency</th>
                <th>USD Amount</th>
                <th>Created</th>
                <th>CC Number</th>
                <th>Trading Account</th>
                <th>PSP</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colspan="12">No transactions</td>
              </tr>
            </tbody>
          </table>
        </section>
      } @else if (tab() === 'profile') {
        <section class="prof-panel">
          <dl class="profile-list">
            <div><dt>Address</dt><dd>{{ person.address || '—' }}</dd></div>
            <div><dt>City</dt><dd>{{ person.city || '—' }}</dd></div>
            <div><dt>Zip or postal code</dt><dd>{{ person.postalCode || '—' }}</dd></div>
            <div><dt>Country of residence</dt><dd>{{ person.residence || '—' }}</dd></div>
            <div><dt>Nationality</dt><dd>{{ person.nationality || '—' }}</dd></div>
            <div><dt>Date of birth</dt><dd>{{ person.dateOfBirth || '—' }}</dd></div>
          </dl>
        </section>
      } @else if (tab() === 'comms') {
        <section class="prof-panel">
          <p class="prof-empty">Phone {{ person.phone || '—' }} · Email {{ person.email }}</p>
        </section>
      } @else {
        <section class="prof-panel">
          <p class="prof-empty">Nothing recorded on this lead yet.</p>
        </section>
      }
    } @else if (!loaded()) {
      <p>Loading this lead…</p>
    } @else {
      <p>That lead is not on your list.</p>
      <button class="prof-back" type="button" (click)="back()">‹</button>
    }
  </article>

  @if (mailing()) {
    <div class="status-pop-back" role="presentation" (click)="mailing.set(false)" (keydown.escape)="mailing.set(false)">
      <form class="status-pop mail-pop" role="dialog" aria-label="Email" (click)="$event.stopPropagation()" (submit)="sendMail($event)">
        <h2>Email</h2>
        <div class="mail-templates">
          <button type="button" [class.on]="mailTemplate() === 'account'" (click)="applyTemplate('account')">
            <strong>Open an account</strong>
            <span>Signup page</span>
          </button>
          <button type="button" [class.on]="mailTemplate() === 'deposit'" (click)="applyTemplate('deposit')">
            <strong>Make a deposit</strong>
            <span>Sign-in page</span>
          </button>
          <button type="button" [class.on]="mailTemplate() === 'missed'" (click)="applyTemplate('missed')">
            <strong>Missed call</strong>
            <span>We tried to reach them</span>
          </button>
          <button type="button" [class.on]="mailTemplate() === 'trust'" (click)="applyTemplate('trust')">
            <strong>Create Trust Wallet</strong>
            <span>Four pictured steps</span>
          </button>
        </div>
        @if (mailBody()) {
          <div class="mail-sheet">
            <div class="mail-sheet-bar">Capi<em>Trade</em></div>
            <div class="mail-sheet-copy">
              @for (line of mailLines(); track $index) {
                @if (line.startsWith('img:')) {
                  <img class="mail-sheet-pic" [src]="line.slice(4)" alt="" />
                } @else if (line.startsWith('https://')) {
                  <a class="mail-sheet-btn" [href]="line" target="_blank" rel="noopener">{{ linkLabel(line) }}</a>
                } @else {
                  <p>{{ line }}</p>
                }
              }
            </div>
            <div class="mail-sheet-foot">support@capitrade.net</div>
          </div>
        }
        <label>
          From
          <input value="support@capitrade.net" readonly />
        </label>
        <label>
          To
          <input [value]="lead()?.email" readonly />
        </label>
        <label>
          Subject
          <input [value]="mailSubject()" (input)="mailSubject.set($any($event.target).value)" />
        </label>
        <label>
          Message
          <textarea rows="8" [value]="mailBody()" (input)="mailBody.set($any($event.target).value)" placeholder="Write the message"></textarea>
        </label>
        <div class="status-pop-actions">
          <button class="status-cancel" type="button" (click)="mailing.set(false)">Cancel</button>
          <button class="prof-add" type="submit" [disabled]="sendingMail()">{{ sendingMail() ? 'Sending…' : 'Send' }}</button>
        </div>
      </form>
    </div>
  }

  @if (addingNote()) {
    <div class="status-pop-back" role="presentation" (click)="addingNote.set(false)" (keydown.escape)="addingNote.set(false)">
      <form class="status-pop" role="dialog" aria-label="Add note" (click)="$event.stopPropagation()" (submit)="saveNote($event)">
        <h2>Add note</h2>
        <label>
          Personal note
          <textarea rows="4" [value]="noteDraft()" (input)="noteDraft.set($any($event.target).value)" placeholder="Only you will see this"></textarea>
        </label>
        <div class="status-pop-actions">
          <button class="status-cancel" type="button" (click)="addingNote.set(false)">Cancel</button>
          <button class="prof-add" type="submit" [disabled]="savingNote()">{{ savingNote() ? 'Saving…' : 'Save' }}</button>
        </div>
      </form>
    </div>
  }

  @if (editingStatus()) {
    <div class="status-pop-back" role="presentation" (click)="editingStatus.set(false)" (keydown.escape)="editingStatus.set(false)">
      <form class="status-pop" role="dialog" [attr.aria-label]="composerTitle()" (click)="$event.stopPropagation()" (submit)="saveComposer($event)">
        <h2>{{ composerTitle() }}</h2>
        <label>
          Status
          <select [value]="status()" (change)="status.set($any($event.target).value)">
            @for (item of statuses; track item) {
              <option [value]="item" [selected]="status() === item">{{ label(item) }}</option>
            }
          </select>
        </label>
        <label>
          Comment
          <textarea rows="4" [value]="comment()" (input)="comment.set($any($event.target).value)" placeholder="Write a comment"></textarea>
        </label>
        <div class="status-pop-actions">
          <button class="status-cancel" type="button" (click)="editingStatus.set(false)">Cancel</button>
          <button class="prof-add" type="submit" [disabled]="savingStatus()">{{ savingStatus() ? 'Saving…' : 'Save' }}</button>
        </div>
      </form>
    </div>
  }

  @if (admin() && crediting()) {
    <div class="status-pop-back" role="presentation" (click)="cancelCredit()">
      <form class="status-pop" role="dialog" aria-label="Add balance" (click)="$event.stopPropagation()" (submit)="confirmCredit($event)">
        <h2>Add balance</h2>
        @if (failed(); as message) {
          <p class="banner" role="alert">{{ message }}</p>
        }
        <p>This amount is added to the account that signed up with this email. The client sees it as their balance.</p>
        @if (lead(); as person) {
          <p>Current balance: {{ money(person.balance) }}</p>
        }
        <label>
          Amount, $
          <input type="number" min="0.01" step="0.01" inputmode="decimal" [value]="creditAmount()" (input)="creditAmount.set($any($event.target).value)" />
        </label>
        <div class="status-pop-actions">
          <button class="status-cancel" type="button" (click)="cancelCredit()">Cancel</button>
          <button class="prof-add" type="submit" [disabled]="addingCredit()">{{ addingCredit() ? 'Adding…' : 'Add balance' }}</button>
        </div>
      </form>
    </div>
  }

  @if (admin() && confirmingDelete()) {
    <div class="status-pop-back" role="presentation" (click)="cancelDelete()">
      <form class="status-pop" role="dialog" aria-label="Delete lead" (click)="$event.stopPropagation()" (submit)="confirmDelete($event)">
        <h2>Delete this lead?</h2>
        <p>This removes the lead from the CRM. It cannot be undone.</p>
        <div class="status-pop-actions">
          <button class="status-cancel" type="button" (click)="cancelDelete()">Cancel</button>
          <button class="prof-delete" type="submit" [disabled]="deleting()">{{ deleting() ? 'Deleting…' : 'Delete lead' }}</button>
        </div>
      </form>
    </div>
  }
</section>
